import MusicNoteSVG from "@src/assets/img/music-note.svg";
import { theme } from "@src/theme";

const TrackArtWorkImage = ({
  $compressedUI,
  ImgStyle,
  customSize,
  imageUrl,
}: {
  $compressedUI?: boolean;
  ImgStyle?: React.CSSProperties;
  customSize?: string;
  imageUrl?: string;
}): React.JSX.Element => {
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        style={{
          width: customSize ? customSize : $compressedUI ? "40px" : "60px",
          height: customSize ? customSize : $compressedUI ? "40px" : "60px",
          objectFit: "cover",
          transition: "width 0.3s, height 0.3s",
          borderRadius: theme.margins.xsmall,
          ...ImgStyle,
        }}
      />
    );
  }
  return (
    <img
      src={MusicNoteSVG}
      style={{
        backgroundColor: theme.colors.primary,
        width: customSize ? customSize : $compressedUI ? "40px" : "60px",
        height: customSize ? customSize : $compressedUI ? "40px" : "60px",
        objectFit: "scale-down",
        borderRadius: theme.margins.small,
        transition: "width 0.3s, height 0.3s",
        ...ImgStyle,
      }}
    />
  );
};
export default TrackArtWorkImage;
